import type { TModule } from '@modules/core/types';

import { PARTNER_CHAT_ROUTE_PATHS } from './config';
import { PARTNER_CHAT_ROUTES } from './index';

const partnerChatModule: TModule = {
  id: 'partner-chat',
  fallbackRoute: [PARTNER_CHAT_ROUTE_PATHS.partnerConversations],
  permissions: { roles: [] },
  isPublic: false,
  routes: PARTNER_CHAT_ROUTES,
};

export { PARTNER_CHAT_ROUTE_PATHS as PartnerChatRoutePaths };

export default partnerChatModule;
